// AboutUs.js
import 'bootstrap/dist/css/bootstrap.min.css';
import '../../../assets/css/student/about/AboutUs.css';
import { Container } from "react-bootstrap";

const AboutUs = () => {
  return (
    <section className="about-main-section">
      {/* Top Banner */}
      <div className="about-banner">
        <Container>
          <div className="about-banner-inner">
            <h1 className="about-banner-heading">
              <span className="orange-highlight">About Us</span> 
            </h1>
            <p className="about-banner-text">
              We strive to make education accessible to all, supporting students with fees, uniforms, and books so every child can reach their full potential
            </p>
          </div>
        </Container>
      </div>
    </section>
  );
};

export default AboutUs;